import { ICulture } from '../domain/ICulture';
import { IUnit } from '../domain/unit/IUnit';
import Axios from 'axios';

export abstract class UnitsApi {

    private static axios = Axios.create(
        {
            baseURL: process.env.REACT_APP_URLPATH + "Units",
            headers: {
                'Content-Type': 'application/json'
            }
        }
    );

    static async getAll(warehouseId: number, companyId: number, jwt: string, culture: ICulture): Promise<IUnit[]> {
        const url = "";
        try {
            const response = await this.axios.get<IUnit[]>(url, { params: { warehouseId: warehouseId, companyId: companyId, culture: culture.code },
                headers: { Authorization: "Bearer " + jwt } });
            //console.log("getAll Response", response);
            if (response.status === 200) {
                return response.data;
            }
            return [];
        } catch (error) {
            console.log("error: ", (error as Error).message);
            return [];
        }
    }

    static async getDetails(jwt: string, id: number, culture: ICulture): Promise<IUnit | null> {
        const url = "/" + id;
        try {
            const response = await this.axios.get<IUnit>(url, { 
                params: { id: id, culture: culture.code },
                 headers: { Authorization: "Bearer " + jwt } });
            //console.log('getDetails response', response);
            if (response.status === 200) {
                return response.data;
            }
            return null;
        } catch (error) {
            console.log('error: ', (error as Error).message);
            return null;
        }
    }

}